import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    lng: 'de',
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    defaultNS: 'translation',
    ns: ['translation', 'help', 'marketing-pages', 'legal', 'helpdesk', 'activity'],
    resources: {},
    partialBundledLanguages: true,
    interpolation: {
        escapeValue: false,
        defaultVariables: {
            year: new Date().getFullYear().toString(),
        },
    },
    debug: false,
    returnObjects: true,
});

export const syncWithLaravelLocale = (locale: string) => {
    void i18n.changeLanguage(locale);
};

export default i18n;
